export default "__VITE_ASSET__BBztNwI7__"